export default __webpack_public_path__ + "static/media/special-examination.55ac5e05.jpg";